
window.initLazyLoadImages = function(container = document) {
  const sections = container.querySelectorAll(".image-wrapper-load");
  if (!sections.length) return;

  sections.forEach((section) => {
    const images = section.querySelectorAll("img[data-src]");
    if (!images.length) return;

    const loadImages = () => {
      images.forEach((img) => {
        const dataSrc = img.getAttribute("data-src");
        if (dataSrc) {
          img.setAttribute("src", dataSrc);
          img.removeAttribute("data-src");
        }
      });
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadImages();
            obs.unobserve(section);
          }
        });
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0,
      }
    );

    // Check if section is already in view
    const rect = section.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      loadImages(); // Already visible → load immediately
    } else {
      observer.observe(section); // Observe only if not yet visible
    }
  });
};

// Run on page load
document.addEventListener("DOMContentLoaded", () => {
  window.initLazyLoadImages(document);
});